// extracted by mini-css-extract-plugin
export var ___gatsby = "layout-module--___gatsby--9f3dc";
export var main = "layout-module--main--3f0fd";